/**
 * Runtime environment configuration.
 *
 * In production, values come from window.__ENV (injected by env-config.js at container startup).
 * In development, Vite's import.meta.env is used as a fallback.
 */

declare global {
  interface Window {
    __ENV?: Record<string, string>;
  }
}

function getEnv(key: string): string {
  return window.__ENV?.[key] ?? import.meta.env[key] ?? '';
}

export const env = {
  VITE_APP_CLIENT_ID: getEnv('VITE_APP_CLIENT_ID'),
  VITE_APP_SIGN_IN_AUTHORITY: getEnv('VITE_APP_SIGN_IN_AUTHORITY'),
  VITE_APP_AUTHORITY_DOMAIN: getEnv('VITE_APP_AUTHORITY_DOMAIN'),
  VITE_APP_ACCESS_SCOPE: getEnv('VITE_APP_ACCESS_SCOPE'),
  VITE_APP_REDIRECT_URI: getEnv('VITE_APP_REDIRECT_URI'),
  VITE_APP_TOKEN_CACHE_LOCATION: getEnv('VITE_APP_TOKEN_CACHE_LOCATION'),
  VITE_APP_BASE_NAME: getEnv('VITE_APP_BASE_NAME'),
  VITE_APP_BUSINESS_SERVICE_BASE_URL: getEnv('VITE_APP_BUSINESS_SERVICE_BASE_URL'),
  VITE_APP_LOCAL_DEV_AUTH: getEnv('VITE_APP_LOCAL_DEV_AUTH')
} as const;
